import { Col, Container, Row } from "react-bootstrap";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { useLocale } from "@/hooks/useLocale";

export const AwardsPageTextSection = ({ className }) => {
  const locale = useLocale();

  return (
    <div className={className}>
      <Container>
        <Row>
          <Col xs={12}>
            <DynamicHtml path={`page.awards.text.left.${locale}`} />
          </Col>
          <Col xs={12}>
            <DynamicHtml path={`page.awards.text.right.${locale}`} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
